import React, { useEffect, useState } from "react";
//import React, { useState } from "react";
import Patient from "./patient"; // React version of patient.html
import style from "../aj.module.css"; // your existing CSS
import epicLogo from "./epic-logo.png";



const initialPatients = [
  { id: "john-doe", name: "John Doe", mrn: "001245", age: 52, sex: "M", complaint: "Patient claims he must hunt" },
  { id: "matthew-smith", name: "Matthew Smith", mrn: "001246", age: 41, sex: "M", complaint: "Crush Injury" },
  { id: "lisa-cho", name: "Lisa Cho", mrn: "001247", age: 29, sex: "M", complaint: "Collapsed in Museum" },
  { id: "jeremy-coppers", name: "Jeremy Coppers", mrn: "001248", age: 58, sex: "M", complaint: "Fake Family" },
  { id: "tom-nguyen", name: "Tom Nguyen", mrn: "001249", age: 72, sex: "M", complaint: "Left Hand Trying to Choke Self" },
  { id: "sofia-hernandez", name: "Sofia Hernandez", mrn: "001250", age: 58, sex: "F", complaint: "Self Neglect" },
  { id: "naomi-williams", name: "Naomi Williams", mrn: "001251", age: 28, sex: "F", complaint: "Infatuation" },
];

const correctDiagnoses = {
  "john-doe": "clinical lycanthropy",
  "matthew-smith": "apotemnophilia",
  "lisa-cho": "stendhal syndrome",
  "jeremy-coppers": "capgras syndrome",
  "tom-nguyen": "alien hand syndrome",
  "sofia-hernandez": "diogenes syndrome",
  "naomi-williams": "erotomania",
};

export default function Home() {
    const [patients, setPatients] = useState(() => {
    const saved = localStorage.getItem("patients");
    if (saved) return JSON.parse(saved);

    return initialPatients.map((p) => ({
      ...p,
      diagnosis: "",
      status: "Diagnosis not made",
    }));
  });


  const [selectedPatient, setSelectedPatient] = useState(null);

  useEffect(() => {
    localStorage.setItem("patients", JSON.stringify(patients));
  }, [patients]);

  const handleDiagnosisChange = (id, value) => {
    setPatients((prev) =>
      prev.map((p) => {
        if (p.id !== id) return p;
        const typed = value.trim().toLowerCase();
        const correct = correctDiagnoses[id].toLowerCase();
        const status = typed === correct ? "Diagnosis correct" : "Diagnosis not made";
        return { ...p, diagnosis: value, status };
      })
    );
  };

  const openPatient = (id) => setSelectedPatient(id);
  const goBack = () => setSelectedPatient(null);

  // If a patient is selected, show the PatientFile component
  if (selectedPatient) {
    const patientData = patients.find(p => p.id === selectedPatient);
    
    return (
      <Patient
        patientId={selectedPatient}
        diagnosisStatus={patientData?.status}
        diagnosis={patientData?.diagnosis}
        onBack={goBack}
      />
    );
  }

  // Otherwise, show the patient list
  return (
    <div className={`${style.ajBody} ${style.homeScreen}`}>
      <header className={style.ajHeader}>
        <div className={style.logoContainer}>
          <img src={epicLogo} alt="Epic Logo" />
        </div>
        <h1 className={style.ajHeaderH1}>Patient Queue — Clinic 2B</h1>
      </header>

      <div className={style.patientSummary}>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Patient Name</th>
              <th>MRN</th>
              <th>Age</th>
              <th>Sex</th>
              <th>Chief Complaint</th>
              <th>Diagnosis</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((p) => (
              <tr
                key={p.id}
                className={p.status === "Diagnosis correct" ? "correct" : "incorrect"}
                onClick={(e) => {
                  if (!e.target.classList.contains("diagnosis-cell")) openPatient(p.id);
                }}
              >
                <td className={style.checkmark}>
                  {p.status === "Diagnosis correct" ? "✔️" : "❌"}
                </td>
                <td>{p.name}</td>
                <td>{p.mrn}</td>
                <td>{p.age}</td>
                <td>{p.sex}</td>
                <td>{p.complaint}</td>
                <td className="diagnosis-cell">
                  <input
                    type="text"
                    value={p.diagnosis}
                    disabled={p.status === "Diagnosis correct"}
                    onChange={(e) => handleDiagnosisChange(p.id, e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    className={style.diagnosisInput}
                    placeholder="Enter diagnosis"
                  />
                </td>

                <td className={style.status}>{p.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
